import { render, staticRenderFns } from "./extractBidsDialog.vue?vue&type=template&id=4ad77612&scoped=true"
import script from "./extractBidsDialog.vue?vue&type=script&lang=js"
export * from "./extractBidsDialog.vue?vue&type=script&lang=js"
import style0 from "./extractBidsDialog.vue?vue&type=style&index=0&id=4ad77612&scoped=true&lang=scss"
import style1 from "./extractBidsDialog.vue?vue&type=style&index=1&id=4ad77612&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad77612",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-servicesplatform-fe/treasurenet-tnservices-servicesplatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4ad77612')) {
      api.createRecord('4ad77612', component.options)
    } else {
      api.reload('4ad77612', component.options)
    }
    module.hot.accept("./extractBidsDialog.vue?vue&type=template&id=4ad77612&scoped=true", function () {
      api.rerender('4ad77612', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ustnFinance/auction/placeBid/record/extractBidsDialog.vue"
export default component.exports